import { render } from "./SwSnackbarHost.vue?vue&type=template&id=ea17ddd4"
import script from "./SwSnackbarHost.vue?vue&type=script&lang=js"
export * from "./SwSnackbarHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__